
    /**
     */
    function isNull(val){
        return val === null;
    }
    module.exports = isNull;





//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isNull.js
// module id = 1610
// module chunks = 0 1 2